function isVisible(element, vp, topMargin) {
  if (element) {
    const rect = element.getBoundingClientRect();
    // var x = rect.left;
    // var x2 = x + element.offsetWidth;
    const y = rect.top;
    const y2 = y + element.offsetHeight;
    return !(y >= vp.h || y2 < topMargin);
  }
  return null;
}

function Viewport(scrollElement) {
  // this.x = window.pageXOffset;
  // this.w = window.innerWidth;
  // this.x2 = this.x + this.w - 1;
  this.y = scrollElement ? scrollElement.scrollTop : window.pageYOffset;
  this.h = scrollElement ? scrollElement.clientHeight : window.innerHeight;
  this.y2 = this.y + this.h;
  return this;
}

function fetchVisibleItems(
  blocks,
  scrollElement,
  topThreshold = 160,
  topMargin = 0
) {
  const vp = new Viewport(scrollElement);
  const from = 0; // hack -- Priya
  const to = blocks.length; // hack -- Priya
  const array = [];
  // eslint-disable-next-line no-plusplus
  for (let b = from; b < to; ++b) {
    const block = blocks[b];
    if (isVisible(block, vp, topMargin)) {
      if (block.getBoundingClientRect().top > topThreshold) {
        array.push(blocks[b - 1]);
      } else {
        array.push(block);
      }
    }
  }
  return array;
}

// TODO: Need to merge this and the above one
export function fetchVisibleItemsInViewPort(blocks, topMargin = 0) {
  const vp = new Viewport(null);
  const to = blocks.length;
  const array = [];
  for (let b = 0; b < to; b += 1) {
    const block = blocks[b];
    if (
      isVisible(block, vp, topMargin) &&
      block.getBoundingClientRect().top >= topMargin
    ) {
      array.push(block);
    }
  }
  return array;
}

export default fetchVisibleItems;
